import { useEffect, useState } from "react";
import api from "../services/api";
import { BASE_URL } from "../services/api";

const DRIVERS_PER_PAGE = 5;

export default function DriversPage() {
  const [drivers,       setDrivers]       = useState([]);
  const [filter,        setFilter]        = useState("all");
  const [page,          setPage]          = useState(1);
  const [selected,      setSelected]      = useState(null);
  const [showCorrection,setShowCorrection] = useState(false);
  const [docsToFix,     setDocsToFix]     = useState([]);
  const [correctionMsg, setCorrectionMsg]  = useState("");

  const fetchDrivers = () =>
    api.get("/admin/drivers").then(res => setDrivers(res.data)).catch(console.error);

  useEffect(() => { fetchDrivers(); }, []);

  const approveDriver = (id) =>
    api.put(`/admin/drivers/approve/${id}`)
      .then(() => { fetchDrivers(); setSelected(null); })
      .catch(console.error);

  const rejectDriver = (id) =>
    api.put(`/admin/drivers/reject/${id}`)
      .then(() => { fetchDrivers(); setSelected(null); })
      .catch(console.error);

  const requestCorrection = async () => {
    if (docsToFix.length === 0) {
      alert("Sélectionne au moins un document à corriger");
      return;
    }
    try {
      await api.post(`/admin/drivers/${selected.id}/correction`, {
        docs_to_fix: docsToFix,
        message: correctionMsg || `Veuillez corriger : ${docsToFix.join(", ")}`,
      });
      setShowCorrection(false);
      setDocsToFix([]);
      setCorrectionMsg("");
      fetchDrivers();
      setSelected(null);
    } catch (err) {
      console.error(err);
    }
  };

  const revokeDriver = async (driver) => {
   const confirm = window.confirm(
    `Révoquer ${driver.name} ?\n\nCeci va :\n- Supprimer tous ses documents\n- Supprimer son véhicule\n- Repasser son compte en utilisateur simple`
   );
   if (!confirm) return;

   try {
    await api.post(`/admin/drivers/${driver.id}/revoke`);
    alert("✅ Chauffeur révoqué avec succès");
    fetchDrivers(); // recharge la liste
   } catch (e) {
    alert("❌ Erreur : " + (e.response?.data?.error || e.message));
   }
  };

  const filtered   = filter === "all" ? drivers : drivers.filter(d => d.status === filter);
  const totalPages = Math.ceil(filtered.length / DRIVERS_PER_PAGE);
  const paginated  = filtered.slice((page - 1) * DRIVERS_PER_PAGE, page * DRIVERS_PER_PAGE);
  const initials   = (name) => name?.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase() || "??";

  const badgeStyle = (status) => ({
    fontSize: 11, padding: "3px 10px", borderRadius: 20, fontWeight: 500,
    background: status === "approved" ? "#EAF3DE" : status === "pending" ? "#FAEEDA" : status === "incomplete" ? "#FFF3CD" : "#FCEBEB",
    color:      status === "approved" ? "#3B6D11" : status === "pending" ? "#854F0B" : status === "incomplete" ? "#856404"  : "#A32D2D",
  });

  const badgeLabel = (s) =>
    s === "approved"   ? "Approuvé"   :
    s === "pending"    ? "En attente" :
    s === "incomplete" ? "Incomplet"  : "Refusé";

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>🚗 Gestion chauffeurs</h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Validation et suivi des chauffeurs</p>
        </div>
        <div style={{ fontSize: 12, padding: "4px 14px", borderRadius: 20, background: "#E6F1FB", color: "#185FA5", border: "0.5px solid #B5D4F4" }}>
          👥 {drivers.length} chauffeurs
        </div>
      </div>

      {/* Filtres */}
      <div style={{ display: "flex", gap: 8, marginBottom: "1.25rem", flexWrap: "wrap" }}>
        {[["all","Tous"], ["pending","En attente"], ["incomplete","Incomplets"], ["approved","Approuvés"], ["rejected","Refusés"]].map(([val, label]) => (
          <button key={val} onClick={() => { setFilter(val); setPage(1); }} style={{
            fontSize: 13, padding: "6px 16px", borderRadius: 20, cursor: "pointer",
            border: "0.5px solid #ccc",
            background: filter === val ? "#0B3C5D" : "#fff",
            color: filter === val ? "#fff" : "#888",
          }}>{label}</button>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: "#fff", border: "0.5px solid #e5e5e5", borderRadius: 12, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#0B3C5D" }}>
            <tr>
              {["Chauffeur", "Téléphone", "Statut", "Documents", "Actions"].map(h => (
                <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontSize: 12, fontWeight: 500, color: "#fff" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginated.map(d => (
              <tr key={d.id} style={{ borderBottom: "0.5px solid #f0f0f0" }}>
                <td style={{ padding: "12px 14px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div style={{ width: 36, height: 36, borderRadius: "50%", background: "#E6F1FB", color: "#185FA5", fontSize: 12, fontWeight: 500, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden" }}>
                      {d.selfie_url
                        ? <img src={`${BASE_URL}/${d.selfie_url}`} alt="" style={{ width: 36, height: 36, objectFit: "cover" }} />
                        : initials(d.name)
                      }
                    </div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 500, color: "#0B3C5D" }}>{d.name ?? "—"}</div>
                      {d.cin && <div style={{ fontSize: 11, color: "#aaa" }}>CIN: {d.cin}</div>}
                    </div>
                  </div>
                </td>
                <td style={{ padding: "12px 14px", fontSize: 13, color: "#888" }}>{d.telephone}</td>
                <td style={{ padding: "12px 14px" }}>
                  <span style={badgeStyle(d.status)}>{badgeLabel(d.status)}</span>
                </td>
                <td style={{ padding: "12px 14px" }}>
                  <button onClick={() => { setSelected(d); setShowCorrection(false); setDocsToFix([]); }} style={{
                    fontSize: 12, padding: "5px 12px", borderRadius: 6,
                    border: "0.5px solid #B5D4F4", background: "#E6F1FB", color: "#185FA5", cursor: "pointer",
                  }}>
                    👁 Voir dossier
                  </button>
                </td>
                <td style={{ padding: "12px 14px" }}>
                  {(d.status === "pending" || d.status === "incomplete") && (
                    <button onClick={() => approveDriver(d.id)} style={{
                      fontSize: 12, padding: "5px 12px", borderRadius: 6,
                      border: "none", background: "#EAF3DE", color: "#3B6D11",
                      cursor: "pointer", marginRight: 6,
                    }}>✔ Approuver</button>
                  )}
                  {d.status === "approved"   && <span style={{ fontSize: 13, color: "#3B6D11" }}>✅ Validé</span>}
                  {d.status === "rejected"   && <span style={{ fontSize: 13, color: "#A32D2D" }}>⛔ Refusé</span>}
                  {d.status === "incomplete" && <span style={{ fontSize: 13, color: "#856404" }}>⚠️ Incomplet</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div style={{ display: "flex", gap: 6, marginTop: "1.25rem" }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <button key={i} onClick={() => setPage(i + 1)} style={{
            width: 32, height: 32, borderRadius: 6, cursor: "pointer",
            border: "0.5px solid #ccc",
            background: page === i + 1 ? "#0B3C5D" : "#fff",
            color: page === i + 1 ? "#fff" : "#888",
            fontSize: 13,
          }}>{i + 1}</button>
        ))}
      </div>

      {/* ===== MODAL DOSSIER ===== */}
      {selected && (
        <div onClick={() => { setSelected(null); setShowCorrection(false); }} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 16, padding: 24, width: 560,
            maxHeight: "90vh", overflowY: "auto",
          }}>

            {/* Header modal */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 48, height: 48, borderRadius: "50%", overflow: "hidden", background: "#E6F1FB", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, fontWeight: 600, color: "#185FA5" }}>
                  {selected.selfie_url
                    ? <img src={`${BASE_URL}/${selected.selfie_url}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    : initials(selected.name)
                  }
                </div>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 600, color: "#0B3C5D" }}>{selected.name ?? "—"}</div>
                  <div style={{ fontSize: 13, color: "#888" }}>{selected.telephone}</div>
                </div>
              </div>
              <button onClick={() => { setSelected(null); setShowCorrection(false); }} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#888" }}>✕</button>
            </div>

            {/* Infos */}
            <div style={{ background: "#f7f7f7", borderRadius: 10, padding: 16, marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: "#888", marginBottom: 10, fontWeight: 500 }}>INFORMATIONS</div>
              {[
                ["CIN",              selected.cin],
                ["N° Permis",        selected.permis_numero],
                ["Exp. permis",      selected.permis_exp],
                ["Statut",           badgeLabel(selected.status)],
                ["Message admin",    selected.admin_message],
              ].map(([label, val]) => val && (
                <div key={label} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 8 }}>
                  <span style={{ color: "#888" }}>{label}</span>
                  <span style={{ fontWeight: 500, color: label === "Message admin" ? "#854F0B" : "#0B3C5D" }}>{val}</span>
                </div>
              ))}
            </div>

            {/* Documents */}
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: "#888", marginBottom: 10, fontWeight: 500 }}>DOCUMENTS</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                {[
                  ["permis_url",            "Permis"],
                  ["carte_grise_url",       "Carte grise"],
                  ["assurance_url",         "Assurance"],
                  ["visite_technique_url",  "Visite technique"],
                  ["photo_cin_url",         "Photo CIN"],
                  ["photo_vehicule_url",    "Photo véhicule"],
                ].map(([key, label]) => {
                  const needsFix = selected.rejected_docs?.includes(
                    key.replace("_url", "")
                  );
                  return (
                    <button key={key}
                      onClick={() => selected[key] && window.open(`${BASE_URL}/${selected[key]}`, "_blank")}
                      style={{
                        fontSize: 12, padding: "8px 12px", borderRadius: 8,
                        cursor: selected[key] ? "pointer" : "default",
                        border: `0.5px solid ${needsFix ? "#E24B4A" : "#e5e5e5"}`,
                        background: needsFix ? "#FCEBEB" : selected[key] ? "#FAEEDA" : "#f7f7f7",
                        color: needsFix ? "#A32D2D" : selected[key] ? "#854F0B" : "#ccc",
                        textAlign: "left",
                      }}
                    >
                      {needsFix ? "⚠️" : selected[key] ? "👁" : "—"} {label}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* ===== ACTIONS ===== */}
<div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

  {(selected.status === "pending" || selected.status === "incomplete") && (
    <>
      <button onClick={() => approveDriver(selected.id)} style={{
        padding: "10px", borderRadius: 8, border: "none",
        background: "#0B3C5D", color: "#fff", fontSize: 14,
        cursor: "pointer", fontWeight: 500,
      }}>
        ✔ Approuver
      </button>

      <button onClick={() => setShowCorrection(!showCorrection)} style={{
        padding: "10px", borderRadius: 8, border: "none",
        background: "#FFA500", color: "#fff", fontSize: 14,
        cursor: "pointer", fontWeight: 500,
      }}>
        📋 {showCorrection ? "Masquer correction" : "Demander correction"}
      </button>

      {/* ===== FORMULAIRE CORRECTION ===== */}
      {showCorrection && (
        <div style={{ background: "#FAEEDA", borderRadius: 10, padding: 16 }}>

          <p style={{
            fontSize: 14, fontWeight: 600, color: "#0B3C5D", marginBottom: 10
          }}>
            📋 Sélectionne les documents à corriger
          </p>

          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 8,
            marginBottom: 12
          }}>
            {[
              ["selfie", "📸 Selfie"],
              ["photo_cin", "🪪 Photo CIN"],
              ["permis", "📄 Permis"],
              ["carte_grise", "📄 Carte grise"],
              ["assurance", "📄 Assurance"],
              ["visite_technique", "🔧 Visite technique"],
              ["photo_vehicule", "🚗 Photo véhicule"],
            ].map(([key, label]) => (
              <label key={key} style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: 13,
                cursor: "pointer",
                color: docsToFix.includes(key) ? "#854F0B" : "#555",
                fontWeight: docsToFix.includes(key) ? 600 : 400,
              }}>
                <input
                  type="checkbox"
                  checked={docsToFix.includes(key)}
                  onChange={e => {
                    if (e.target.checked) {
                      setDocsToFix(p => [...p, key]);
                    } else {
                      setDocsToFix(p => p.filter(d => d !== key));
                    }
                  }}
                />
                {label}
              </label>
            ))}
          </div>

          <textarea
            value={correctionMsg}
            onChange={e => setCorrectionMsg(e.target.value)}
            placeholder="Message personnalisé au chauffeur (optionnel)..."
            rows={3}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: 8,
              border: "0.5px solid #FAC775",
              fontSize: 13,
              fontFamily: "inherit",
              resize: "vertical",
              marginBottom: 10,
              boxSizing: "border-box",
            }}
          />

          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={requestCorrection} style={{
              flex: 1,
              padding: "10px",
              borderRadius: 8,
              border: "none",
              background: "#FFA500",
              color: "#fff",
              fontSize: 13,
              cursor: "pointer",
              fontWeight: 500,
            }}>
              📩 Envoyer la demande
            </button>

            <button
              onClick={() => {
                setShowCorrection(false);
                setDocsToFix([]);
              }}
              style={{
                padding: "10px 16px",
                borderRadius: 8,
                border: "0.5px solid #ccc",
                background: "#fff",
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              Annuler
            </button>
          </div>
        </div>
      )}

      <button onClick={() => rejectDriver(selected.id)} style={{
        padding: "10px",
        borderRadius: 8,
        border: "none",
        background: "#FCEBEB",
        color: "#A32D2D",
        fontSize: 14,
        cursor: "pointer",
        fontWeight: 500,
      }}>
        ✖ Rejeter définitivement
      </button>
    </>
  )}

  {/* ===== RÉVOCATION ===== */}
  <button
    onClick={() => revokeDriver(selected)}
    style={{
      padding: "10px",
      borderRadius: 8,
      border: "none",
      background: "#dc3545",
      color: "#fff",
      fontSize: 14,
      cursor: "pointer",
      fontWeight: 500,
    }}
  >
    🚫 Révoquer
  </button>

</div>
          </div>
        </div>
      )}

    </div>
  );
}